/**
 * Formats a number as a currency string with a dollar sign and two decimal places.
 * Defaults missing/undefined values to $0.00.
 */
export const formatCurrency = (value?: number) => `$${(value ?? 0).toFixed(2)}`;
